import * as React from "react";
import { Stack, Box, Typography } from "@mui/material";
import { HeaderNavProps } from "@/components/header/common/types";
import { ColletteButton } from "@collette-travel/collette-common-controls";
import { useTranslations } from "next-intl";

type MobileSecondaryNavigationItemCardsProps = {
  tertiaryNavItems: HeaderNavProps[];
  tertiaryHeaderLearnMoreUrl?: string;
  tertiaryHeaderViewAllDestinationsUrl?: string;
};
export default function MobileSecondaryNavigationItemCards(props: MobileSecondaryNavigationItemCardsProps) {
  const { tertiaryHeaderLearnMoreUrl, tertiaryHeaderViewAllDestinationsUrl, tertiaryNavItems } = props;
  const t = useTranslations("COMMON");
  return (
    <Stack direction="row">    
      <Box
        data-testid={`tertiary-pane-content-card-${tertiaryNavItems[0]?.fields.title}`}
        sx={{
          width: "100%"
        }}
      >
        <Box>
          <Stack direction="column">
            <Box sx={{ pl: 4, width: "85%" }}>
              <Typography
                sx={{ 
                  color: "text.primary",
                  fontWeight: "500",
                  fontSize: "14px"
                }}
              >
                {tertiaryNavItems[0]?.fields.content?.content[0]?.content[0]?.value}
              </Typography>
            </Box>
          </Stack>
          <Box sx={{ 
            display: "flex", 
            justifyContent: "center", 
            gap: 1,
            pt: 1.5 
          }}>
            {tertiaryHeaderLearnMoreUrl && (
             <ColletteButton
                       variant="outlined"
                       href={tertiaryHeaderLearnMoreUrl}
                       label={t("Learn More")}
                       testId="learn-more-button"
                       data-track="click"
                       sx={{
                         color: "primary.main",
                         borderColor: "primary.main",
                         backgroundColor: "background.default",
                         textTransform: "none",
                         fontSize: "1.4rem!important",
                         padding: "0.5rem 1.2rem!important",
                         gap: "8px!important",
                         lineHeight: "2rem",
                         letterSpacing: "0.01rem",
                         borderRadius: "10rem!important",
                         height: "30px",
                         "&:hover": {
                           backgroundColor: "background.cool_strong"
                         }
                       }}
                     />
            )}
            {tertiaryHeaderViewAllDestinationsUrl && (
               <ColletteButton
                       variant="outlined"
                       href={tertiaryHeaderViewAllDestinationsUrl}
                       label={t("View All Tours")}
                       testId="homepage-expert-section-cta-button"
                       data-track="click"
                       sx={{
                         color: "secondary.contrastText",
                         borderColor: "secondary.main",
                         backgroundColor: "secondary.main",
                         textTransform: "none",
                         fontSize: "1.4rem!important",
                         padding: "0.5rem 1.2rem!important",
                         gap: "8px!important",
                         lineHeight: "2rem",
                         letterSpacing: "0.01rem",
                         borderRadius: "10rem!important",
                         height: "30px",
                         "&:hover": {
                           backgroundColor: "background.cool_strong"
                         }
                       }}
                     />
            )}
          </Box>            
        </Box>
      </Box>
    </Stack>
  );
}
